import { useQuery } from '@tanstack/react-query'
import { useTypedApiClient } from 'hooks/useTypedApiClient'

export const useGetAllSystemBanners = () => {
  const get = useTypedApiClient({
    path: '/admin/system-banners',
    method: 'get',
  })

  return useQuery({
    queryKey: ['/admin/system-banners'],
    queryFn: async () => {
      const { data } = await get({})
      return data
    },
  })
}
